// extracted by mini-css-extract-plugin
export default {"skills-wrapper":"style_skills-wrapper__kaQD-","skillsWrapper":"style_skills-wrapper__kaQD-"};